module.exports = __webpack_public_path__ + "static/media/test-speedometer.c6f9ae77.svg";